import { DeviceSelection, DeviceType } from '../DeviceSelectionGallery.types'
import {
  getDeviceIneligiblityMessages,
  MappedUtilityProgram,
} from '@/reducers/programsNew'
import { isDeviceAllowedInProgram } from '@/app/hooks/useUtilityPrograms'

type DeviceInput = { id: number | string; type: DeviceType }

function countAvailableProgramsForDevice(
  device: DeviceInput,
  availablePrograms: MappedUtilityProgram[],
): number {
  let count = 0
  for (const program of availablePrograms) {
    const messages = getDeviceIneligiblityMessages(
      program.device_eligibility_overview.devices,
    )
    if (
      isDeviceAllowedInProgram(
        device.id,
        device.type,
        program.device_eligibility_overview,
        messages,
      )
    ) {
      count++
    }
  }
  return count
}

export function computeBestAutoSelectDevice(
  devices: DeviceInput[],
  availablePrograms: MappedUtilityProgram[],
): DeviceSelection | null {
  if (devices.length === 0 || availablePrograms.length === 0) {
    return null
  }

  const devicesWithCounts = devices.map((device) => ({
    device,
    programCount: countAvailableProgramsForDevice(device, availablePrograms),
  }))

  const realDevicesWithPrograms = devicesWithCounts.filter(
    (d) => d.device.type !== 'home' && d.programCount > 0,
  )

  if (realDevicesWithPrograms.length > 0) {
    realDevicesWithPrograms.sort((a, b) => b.programCount - a.programCount)
    const best = realDevicesWithPrograms[0].device
    return { id: String(best.id), type: best.type }
  }

  const homeWithPrograms = devicesWithCounts.find(
    (d) => d.device.type === 'home' && d.programCount > 0,
  )

  if (homeWithPrograms) {
    return {
      id: String(homeWithPrograms.device.id),
      type: homeWithPrograms.device.type,
    }
  }

  return null
}
